<template>
    <div>


        <div class="multi-bg-example pa-12">
         


                <div class="pa-md-12 mt-12 " style="max-width: 684px;">


                    <p class="ml-md-12 white--text mt-12" style="font-family:'inter';   font-size:17px; line-height:38px;">Ayoola Falola says,</p>

                    <h4 style="font-family:'inter'; letter-spacing: -1.5px;  font-size:59px; line-height:80px;  " class="white--text  pl-md-12">Together!, let's Reclaim Nigeria</h4>


                    <p class="ml-md-12 white--text mt-12" style="font-family:'inter';   font-size:17px; line-height:38px;">With our collective efforts; our money and our vote. we can do it.</p>

                    <div class="d-flex mt-12 ml-md-12 " style="font-family:'inter';">
                        <v-btn class="orange white--text text-capitalize" depressed large href="#pay">Support Now</v-btn>
                        <v-btn text outlined large class="ml-md-7 white--text text-capitalize" target="_blank" href="https://ayoo.la/2023">Learn about our plans.</v-btn>
                    </div>

                </div>
         
        </div>

        <div class="grey lighten-3 text-center  d-flex justify-center">


            <div style="font-family:'inter';  " class="pa-12 ">
                <h4 class=" mt-12 text-center" style="font-size:40px; font-weight:500;">Our Plan</h4>
                <v-divider class="orange text-center mt-3 " style="max-height:5px;  height:5px; "></v-divider>
                <p class="mt-12  mb-12  text-center" style="max-width: 1000px; font-weight:300; font-size:28px; line-height:45px;">We believe with our collective efforts , we will reach our goal. However, in the case we do not meet up to the minimum required, we shall refund all your monies including those you reffered.</p>

                <h4 class=" mt-12  pt-12 text-center" style="font-size:40px; font-weight:500;">Our Budget</h4>
                <v-divider class="orange text-center mt-3 " style="max-height:5px;  height:5px; "></v-divider>
                <p class="mt-12   text-center" style="max-width: 1000px; font-weight:300; font-size:28px; line-height:45px;">With your minimum of 2000 naira and from your circle we believe we can raise 100 million naira. Pay your 2000 naira and invite your friends to do same using your phone number as the sponsor number.</p>

            </div>
        </div>
        <div class="blue ">
          


                <v-row class="pa-12 white--text" style="font-family: 'inter';">
                    <v-col md="4" cols="12">
                        <div class="text-center d-flex ">
                            <v-icon style="font-size:100px;  " color="white" x-large>mdi-gauge</v-icon>
                            <div>


                                <h5 style="font-size:20px; font-weight:600;  line-height:20.57px; " class="mt-8">100 Million Naira</h5>
                                <p class=" pr-5 pl-5 mt-1 black--text" style="font-weight:400; font-size:16px; line-height:20px;">
                                    Budget
                                </p>
                            </div>

                        </div>

                    </v-col>
                    <v-col md="4" cols="12">
                        <div class="text-center d-flex ">
                            <v-icon color="white" style="font-size:100px;  " x-large>mdi-finance</v-icon>
                            <div>


                                <h5 style="font-size:20px; font-weight:600;  line-height:20.57px; " class="mt-8">60 Million Naira</h5>
                                <p class=" pr-5 pl-5 mt-1 black--text" style="font-weight:400; font-size:16px; line-height:20px;">
                                    Threshold Budget
                                </p>
                            </div>
                        </div>



                    </v-col>
                    <v-col md="4" cols="12">
                        <div class="text-center d-flex">
                            <v-icon style="font-size:100px;  " color="white" x-large>mdi-google-circles</v-icon>
                            <div>


                                <h5 style="font-size:20px; font-weight:600;  line-height:20.57px; " class="mt-8">2,000 Naira</h5>
                                <p class=" pr-5 pl-5 mt-1 black--text" style="font-weight:400; font-size:16px; line-height:20px;">
                                    Recommended Minimum value to contribute
                                </p>
                            </div>
                        </div>

                    </v-col>
                </v-row>
           
                </div>

        <div class="grey lighten-4 pa-12">
           


                <v-row>
                    <v-col md="5" class="pl-md-12" cols="12">
                        <h3 class="  mt-4" style="font-weight: 500; font-size: 30px; line-height: 20.51px; font-family: 'inter'; ">Be Part of this system as.</h3>
                        <v-list style="background-color:transparent;" class="mt-6 ml-5" dense>


                            <v-list-item>
                                <v-list-item-avatar style="height:90px; width: 90px;">
                                    <v-icon style="font-size:100px;" color="red"> mdi-bank</v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title style="font-family: 'inter'; font-weight:400; font-size:20px;">Cabinet Member</v-list-item-title>
                                    <!--<v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>-->
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item class=" ml-4 ml-md-12 mt-n3">
                                <v-list-item-avatar style="height:90px; width: 90px;">
                                    <v-icon style="font-size:100px;" x-large color="blue">mdi-card-account-phone </v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title style="font-family: 'inter'; font-weight:400; font-size:20px;">Advisories</v-list-item-title>
                                    <!--<v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>-->
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item class="mt-n3">
                                <v-list-item-avatar style="height:90px; width: 90px;">
                                    <v-icon x-large color="green" style="font-size:100px;"> mdi-chart-bubble</v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title style="font-family: 'inter'; font-weight:400; font-size:20px;">Inner Cacaus</v-list-item-title>
                                    <!--<v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>-->
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col md="7" cols="12" style="font-family:'inter';  border-left-color:orange; border-left-width:2px;  border-left-style:solid;" class="pa-12 ">

                        <h3 class="text-capitalize  " style="font-weight:400; font-size:30px;  line-height:20.51px;">Recent Contributors</h3>
                        <v-list style="background-color:transparent;" class="mt-3">
                            <v-list-item v-for="(itemer, i) in recentorders"
                                         :key="itemer.orderID">
                                <v-list-item-avatar>
                                    <v-icon color="green" > mdi-chart-bubble</v-icon>
                                    <!--<v-icon v-if="cabinet" color="green" :src="item.avatar"> mdi-chart-bubble</v-icon>
                        <v-icon v-if="cabinet" color="green" :src="item.avatar"> mdi-chart-bubble</v-icon>-->
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title v-html="itemer.OrderAmountFormatted"></v-list-item-title>
                                    <v-list-item-subtitle v-html="itemer.name"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
           
                </div>


    </div>
</template>

<script>
   

    import { CoreService } from '@/services/core.service'
    export default {

        name: 'Home',
        props: {
            msg: String
        },
        data() {
            return {
                
                
              
             
                recentorders: [],
                authenticating: false,
               
                           }
        },
        components: {
          
        },
        methods: {
         
            async load() {
             

                var ky = await CoreService.getRecentOrders();

                this.recentorders = ky.data;

                this.recentorders.forEach(async (b) => {
                  /*  b.Mdate = new Date(b.orderDate).toLocaleString();*/
                    const formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'NGN',
                        minimumFractionDigits: 2
                    })

                    b.OrderAmountFormatted = formatter.format(b.amount);
                  

                    
                });
               
            },
           
        },
        beforeMount() {



            this.load();
           
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    @media only screen and (max-width: 600px) {
        .multi-bg-example {
            width: 100%;
            height: 884px;
            background-image:  linear-gradient(262.2deg, #2E368F -90.39%, #2AACE2 141.93%);
            background-repeat: no-repeat, no-repeat, no-repeat;
            background-position: bottom right, left, right;
        }
    }
    @media only screen and (min-width: 992px) {


        .multi-bg-example {
            width: 100%;
            height: 884px;
            background-image: url(../assets/modelmask.png), linear-gradient(262.2deg, #2E368F -90.39%, #2AACE2 141.93%);
            background-repeat: no-repeat, no-repeat, no-repeat;
            background-position: bottom right, left, right;
        }
    }
     .multi-bg-example::before {
            background-size:contain ;
            position: absolute;
            top: 0px;
            content: "";
            right: 0px;
            bottom: 0px;
            left: 0px;
            opacity: 0.1;
            background-image: url(../assets/patternmask.png);
        }
</style>

